import log from 'loglevel';

const LoggerService = log.getLogger('BhabiUI');
LoggerService.setLevel('debug');

export { LoggerService };
